export var CardHeight = '220px';
export var CardMinWidth = '254px';
export var CardMaxWidth = '368px';
export var CardPreviewHeight = '155px';
export var CardHeaderTitleWidth = '164px';
export var CardPreviewArtifactHeight = '128px';
export var CardArtifactMinWidth = '254px';
export var CardArtifactMaxWidth = '368px';
//# sourceMappingURL=StyleConstants.js.map